/**
 * Created by or_p on 11/29/2016.
 */
export const REVISE_STATUS = {
  PROCESSING: 1,
  SUCCESS: 2,
  ERROR: 3,
  RETRYING: 4,
};
